export function withReducerName(path) {
    return `${reducerName}.${path}`;
}
export const reducerName = 'registry';
export const reduxStateMap = {
    USER_PROFILE: 'userProfile',
    CONFIGURATION: 'configuration',
    DATA: 'data',
    SEARCH_TERM: 'searchTerm',
    VEHICLE_TYPE: 'vehicleType',
    QUERY_TYPE: 'queryType',
    FORM_VALUES: 'formValues',
    IS_LOADING: 'isLoading',
    SERVICE_BREAK: 'configuration.ServiceBreak',
    ALERT_MESSAGE: 'alertMessage'
};
